import { openCloudinaryWidget, isCloudinaryWidgetOpen, preloadCloudinaryWidget } from 'js/lib/cloudinary'
import $ from 'cash-dom'

initialize()

async function initialize() {
  const imgUploads = $('.js-c-img-upload-input')
  if (!imgUploads.length) return

  preloadCloudinaryWidget()

  imgUploads.each((_, el) => {
    const imgUpload = $(el)
    imgUpload.on('click', '.js-c-img-upload-input__button', event => {
      event.preventDefault()
      handleImageUpload(el)
    })
  })
}

async function handleImageUpload(element) {
  if (isCloudinaryWidgetOpen()) return

  const { tag, allowedFormats, maxImageWidth, maxImageHeight, minImageWidth, minImageHeight } = JSON.parse(
    element.dataset.clientState
  )

  const results = await openCloudinaryWidget({
    uploadPreset: 'no_transforms',
    tags: [tag],
    multiple: false,
    sources: ['local', 'url'],
    maxFileSize: 25 * 100000, // 25 MB
    resourceType: 'image',
    allowedFormats,
    maxImageWidth,
    maxImageHeight,
    minImageWidth,
    minImageHeight,
  })

  if (!results.length) return

  const info = results[0].info
  const imageUrl = info.secure_url

  const thumbnailUrl = imageUrl.replace('/upload/', '/upload/h_176,c_fit,q_auto,f_auto/')

  const $thumbnailContainer = $(element).find('.js-c-img-upload-input__thumbnail')
  const $img = $thumbnailContainer.find('img')
  const $hiddenInput = $(element).find('.js-c-img-upload-input__hidden-input')

  $thumbnailContainer.removeClass('hidden')
  $thumbnailContainer.addClass('tw-animate-pulse tw-bg-neutral-100')

  const tempImg = new Image()
  tempImg.onload = () => {
    $thumbnailContainer.removeClass('tw-animate-pulse tw-bg-neutral-100 tw-hidden')
    $img.attr('src', thumbnailUrl)
  }
  tempImg.onerror = () => {
    $img.attr('src', imageUrl)
    $thumbnailContainer.removeClass('tw-animate-pulse tw-bg-neutral-100 tw-hidden')
  }
  tempImg.src = thumbnailUrl

  $hiddenInput.attr('value', imageUrl)
}
